module.exports = __webpack_public_path__ + "8bb08098240b8200149bf15626039c54.png";


//////////////////
// WEBPACK FOOTER
// ./images/logout-icon.png
// module id = 507
// module chunks = 0